import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { BehaviorSubject, Observable } from 'rxjs';
import { URL_SERVICIOS_SOCKET } from '../config/config';
import { ENVIRONMENT } from '../config/config';

@Injectable({
  providedIn: 'root'
})
export class ChatSocketService {
    private socket: Socket;

    constructor() {
      this.socket = io(URL_SERVICIOS_SOCKET, {
            transports: ['websocket'],
            withCredentials: true
        });

      this.socket.on('connect', () => {
        console.log('✅ Conectado a socket chats, url socket:', URL_SERVICIOS_SOCKET, 'ambiente:', ENVIRONMENT);
      });

      this.socket.on('connect_error', (err) => {
        console.error('❌ Error de conexión socket chats:', err, 'url socket:', URL_SERVICIOS_SOCKET, 'ambiente:', ENVIRONMENT);
      });
    }

    joinRoom(data)
    {
        this.socket.emit('chat:join',data);
    }

    created()
    {
        let observable = new Observable<{user:String, message:String}>(observer=>{
            this.socket.on('chat:created', (data)=>{
                observer.next(data);
            });
            return () => {this.socket.disconnect();}
        });
        return observable;
    }

    joined()
    {
        let observable = new Observable<{user:String, message:String}>(observer=>{
            this.socket.on('chat:joined', (data)=>{
                observer.next(data);
            });
            return () => {this.socket.disconnect();}
        });
        return observable;
    }

    userJoined()
    {
        let observable = new Observable<{user:String, message:String}>(observer=>{
            this.socket.on('chat:userJoined', (data)=>{
                observer.next(data);
            });
            return () => {this.socket.disconnect();}
        });
        return observable;
    }

    message()
    {
        let observable = new Observable<{user:String, message:String}>(observer=>{
            this.socket.on('chat:message', (data)=>{
                observer.next(data);
            });
            return () => {this.socket.disconnect();}
        });
        return observable;
    }

    leave()
    {
        let observable = new Observable<{user:String, message:String}>(observer=>{
            this.socket.on('leave', (data)=>{
                observer.next(data);
            });
            return () => {this.socket.disconnect();}
        });
        return observable;
    }

    emitSocket(topic, data) {
        if (topic && data) {
            this.socket.emit('chat:'+topic, data);
        }
    }
}
